import { render, staticRenderFns } from "./ContentItemsViewPermissionsCard.vue?vue&type=template&id=c63034da&"
import script from "./ContentItemsViewPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./ContentItemsViewPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports